import TacticalPage from "./getquote.page"

export default TacticalPage;
